<template>
  <section class="sec-banner">
    <div class="float-bg" />
    <div class="banner-wrapper" @click="goRouterCarnivalIp" v-rseat="'click_carnival_ip'" />
  </section>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    goRouterCarnivalIp() {
      this.$router.push({ name: 'carnival2020-ip' }, () => {
        document.body.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
      })
    },
  },
}
</script>
<style lang="less">
.sec-banner {
  position: relative;
  max-width: 1101px;
  margin: 0 auto;
  .float-bg {
    left: -317px;
    top: -30px;
    transform: rotate(150deg);
    width: 644px;
    height: 247px;
  }
  .banner-wrapper {
    position: relative;
    z-index: 2;
    width: 1069px;
    height: 292px;
    background: url('~@/assets/carnival2020/banner_ip.png') no-repeat;
    background-size: contain;
    cursor: pointer;
  }
}
</style>
